export default __webpack_public_path__ + "static/media/cremer.0a8d4388.jpg";